
import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import RecipeService, { FullData, Recipe } from '@/services/recipes.service';

@Component
export default class SodiumAdded extends Vue {
  @Prop() private model!: Recipe;

  updateValue() {
    const value = this.model.sodium_added;
    RecipeService.updateOne(this.model.id, {
        sodium_added: value,
      }).then((data:FullData) => {
            this.$store.commit('updateRecipe', data.label);
            this.$store.commit('updateTable', data.table);
      }).catch(error => {
        console.log(error);
      });
  }
}
